import styled from "styled-components";

interface IDotNotification {
  width?: number;
  height?: number;
  marginLeft?: number;
  marginRight?: number;
}

export const DotNotification = styled.div<IDotNotification>`
  width: ${({ width }) => width || 6}px;
  height: ${({ height }) => height || 6}px;
  border-radius: 50%;
  margin-left: ${({ marginLeft }) => marginLeft || 0}px;
  margin-right: ${({ marginRight }) => marginRight || 0}px;
  background-color: ${({ theme }) => theme.colors.notification.notification};
`;
